import * as React from "react";
import { FC } from "react";
import { AwardZabrzeEntrypoint } from "../../../entrypoints/award-zabrze";
import { LANG } from "../../../common/types/localization";
import { DefaultLayout } from "../../../components/layout/default";

export default (): FC => (
  <DefaultLayout
    lang={LANG.plPL}
    entrypoint={"award-zabrze"}
    page={"nagroda_kultury_miasta_zabrze"}
  >
    <AwardZabrzeEntrypoint lang={LANG.plPL} />
  </DefaultLayout>
);
